import axios from './axios_web';

import * as actionTypes from './actionTypes';

export const logInOTPStart = () => ({
  type: actionTypes.LOG_IN_OTP_START,
});

export const logInOTPSuccess = () => ({
  type: actionTypes.LOG_IN_OTP_SUCCESS,
});

export const logInOTPFail = (error) => ({
  type: actionTypes.LOG_IN_OTP_FAIL,
  error,
});

export const verifyOTPReset = () => ({
  type: actionTypes.VERIFY_OTP_RESET,
});

export const logInOTPBegin = (email, captchaToken) => (
  (dispatch) => {
    dispatch(verifyOTPReset());
    dispatch(logInOTPStart());
    const url = '/login';
    const data = {
      email,
      captcha_token: captchaToken,
    };
    axios.post(url, data)
      .then((response) => {
        if (response.status === 204) {
          dispatch(logInOTPSuccess());
        } else {
          dispatch(logInOTPFail(response.data.detail));
        }
      })
      .catch((err) => {
        let error = err.message;
        if (err.response && err.response.data) {
          error = err.response.data.error;
        }
        dispatch(logInOTPFail(error));
      });
  }
);
